import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { EopAssistantComponent } from '../../components/eop-assistant/eop-assistant.component';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { PrvNextButtonsComponent } from '../../components/prv-next-buttons/prv-next-buttons.component';
import { PopupMessageComponent } from '../../components/popup-message/popup-message.component';
import { IntroductionComponent } from '../../components/introduction/introduction.component';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';
import { UserDataService } from '../../../shared/services/userData.service';
import { IThreat } from '../../../shared/models/threat';
import { ThreatService } from '../../../shared/services/threat.service';
import { ThreatDetailsComponent } from './threat-details/threat-details.component';
import { NewThreatComponent } from './new-threat/new-threat.component';
import { DeleteConfirmationComponent } from '../../components/delete-confirmation/delete-confirmation.component';
import { ThreatEditComponent } from "./threat-edit/threat-edit.component";
import { EopNavigationService } from '../../../shared/services/eopNavigation.service';
import { ESectionTypes } from '../../../shared/models/eop_types.enum';
import { IUserInfo } from '../../../shared/models/contact';

@Component({
  selector: 'app-threats-hazards',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    EopAssistantComponent,
    SpinnerComponent,
    PrvNextButtonsComponent,
    PopupMessageComponent,
    IntroductionComponent,
    ThreatDetailsComponent,
    NewThreatComponent,
    DeleteConfirmationComponent,
    ThreatEditComponent
],
  templateUrl: './threats-hazards.component.html',
  styleUrl: './threats-hazards.component.css'
})
export class ThreatsHazardsComponent implements OnInit{

  icons = Icons;
  sectionType = ESectionTypes['Threat & Hazard'];
  currentUserId: string = '';
  currentBuildingId: string | null = null;
  currentUser: IUserInfo | null = null;
  threatsList: IThreat[] = [];
  selectedThreat: IThreat | null = null;
  messageModal: string | null = null;
  popupMessage: string = '';

  loading: boolean = false;
  showAddNewThreat: boolean = false;
  showDeleteConfirmation: boolean = false;
  showEditThreat: boolean = false;
  showThreatDetails: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private threatService: ThreatService,
    public eopNavigationService: EopNavigationService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentUser = this.userDataService.getUserData();
    this.loadThreats();
  }

  loadThreats(): void {
    if (!this.currentBuildingId) {
      console.error('No building ID found. Cannot load threats.');
      return;
    }
    this.loading = true;
    this.threatService.getThreats(this.currentBuildingId).subscribe({
      next: (response) => {
        this.threatsList = response && response.data ? response.data : [];
        // Sort the list after retrieving threats list.
        if (this.threatsList.length > 0) {
          this.threatsList.sort((a: IThreat, b: IThreat) => a.threat.localeCompare(b.threat));
        }
        this.loading = false;
        console.log(response)
      },
      error: (error: any) => {
        this.loading = false;
        console.error('Error loading contacts:', error.message);
      }
    })
  }

  handleOpenModal(modalName: string, selectedItem?: any): void {
    if (modalName === 'new-threat') {
      this.showAddNewThreat = true;
    } else if (modalName === 'edit-threat') {
      this.showEditThreat = true;
    } else if (modalName === 'threat-details') {
      this.showThreatDetails = true;
    } else if (modalName === 'delete-confirmation') {
      this.showDeleteConfirmation = true;
    }
    this.selectedThreat = selectedItem? selectedItem : null;
  }

  handleCloseModal(modalName: string): void {
    if (modalName === 'new-threat') {
      this.showAddNewThreat = false;
    } else if (modalName === 'edit-threat') {
      this.showEditThreat = false;
    } else if (modalName === 'threat-details') {
      this.showThreatDetails = false;
    } else if (modalName === 'delete-confirmation') {
      this.showDeleteConfirmation = false;
    }
    this.selectedThreat = null;
  }

  handleSave(message: {type: string, message: string}, actionType: string): void {
    this.loadThreats();
    this.handleCloseModal(actionType);

    if (message.type === 'success') {
      this.messageModal = 'success';
      this.popupMessage = message.message;
      
    } else if (message.type === 'unsuccess') {
      this.messageModal = 'unsuccess';
      this.popupMessage = message.message;
    } 
  }

  handleDelete(item: any): void {
    this.showDeleteConfirmation = false;
    this.loading = true;
    this.threatService.deleteThreat(String(item.id)).subscribe({
      next: (response) => {
        this.selectedThreat = null;
        this.loading = false;
        this.messageModal = "success";
        this.popupMessage = 'This occurred after deleting a threat.';
        this.loadThreats();
        console.log(response);
      },
      error: (error: any) => {
        this.selectedThreat = null;
        this.loading = false;
        this.messageModal = "unsuccess";
        this.popupMessage = error.message;
        console.error('Error deleting threat:', error.message);
      }
    })
  }
  
  canSave(): boolean {
    if (!this.currentUser) return false;
    return this.currentUser.can_edit || this.currentUser.can_admin;
  }

  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = '';
  }
}
